import LabelForDueDateField from './LabelForDueDateField'

export default LabelForDueDateField
